//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Original Author: Aaron Turnblom
 * Original Team: Area 51
 */
import { VInput } from 'vuetify/lib';
import NsDatePicker from '../../NsDatePicker.vue';
import { PropsMixin, LocaleMixin, RulesMixin, ModelMixin } from '../mixins';

export default {
  name: 'NsDatePickerSelectField',
  components: {
    NsDatePicker,
    VInput,
  },
  mixins: [PropsMixin, ModelMixin({ deep: false }), RulesMixin, LocaleMixin],
  props: {
    /**
     * Field value
     * @type {object}
     */
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    dateLocale() {
      if (this.locale) {
        return this.locale.replace('_', '-');
      }
      return null;
    },
  },
  methods: {
    handleShown(val) {
      // If closing the menu, force the validation to run
      // and display error messages
      if (!val) {
        this.$refs.vinput.validate(true);
      }
    },
  },
};
